import Image from 'next/image';
import { Typography } from '../typography';
import clsx from 'clsx';

interface Props {
	message: string;
	srdImg?: string;
	className?: string;
	width?: number;
	height?: number;
}

export const EmptyBox: React.FC<Props> = ({
	message,
	width = 188,
	height = 150,
	className,
}) => {
	return (
		<div
			className={clsx(
				'h-[80%] flex flex-col justify-center items-center',
				className
			)}
		>
			<Image
				src={'/img/common/empty.png'}
				width={width}
				height={height}
				alt="empty"
				quality={75}
			/>
			<Typography
				type="regular-18"
				className="font-normal text-center px-8 md:px-0"
			>
				{message}
			</Typography>
		</div>
	);
};
